const brands = [
  'news',
  'today',
  'msnbc',
];

const newsVerticals = [
  'mach',
  'better',
  'think',
  'globalcitizen',
  'know-your-value',
  'leftfield',
];

const telemundoVerticals = [
  'noticias',
  'shows',
  'entretenimiento',
  'telemundo',
];

const verticalNameMap = {
  better: 'BETTER',
  globalcitizen: 'Global Citizen',
  knowyourvalue: 'Know Your Value',
  leftfield: 'Left Field',
  mach: 'MACH',
  msnbc: 'MSNBC',
  news: 'NBC News',
  think: 'THINK',
  today: 'TODAY',
  noticias: 'Noticias Telemundo',
};

const verticalSlugMap = {
  better: 'better',
  globalcitizen: 'global-citizen',
  knowyourvalue: 'know-your-value',
  leftfield: 'left-field',
  mach: 'mach',
  msnbc: 'msnbc',
  news: 'news',
  think: 'think',
  today: 'today',
  noticias: 'noticias',
};

const verticals = [
  ...brands,
  ...newsVerticals,
  'noticias',
];

const verticalSiteConfigs = {
  news: {
    iconUrl: 'nbcnews',
    siteCreator: 'NBCNews',
    siteLogoUrl: 'https://sslnodeassets.nbcnews.com/cdnassets/projects/site-images/nbcnews-logo-white.png',
    siteName: 'NBC News',
    siteParamFacebook: 'nbcnews',
    siteParamInstagram: 'nbcnews',
    siteParamTwitter: 'nbcnews',
    siteParamYoutube: 'nbcnews',
    siteSite: '@NBCNews',
    siteUrl: 'http://www.nbcnews.com',
    twitterIntentVia: 'NBCNews',
  },
  today: {
    iconUrl: 'today',
    siteCreator: 'TodayShow',
    siteLogoUrl: 'https://sslnodeassets.nbcnews.com/cdnassets/projects/site-images/nbcnews-logo-white.png',
    siteName: 'TODAY.com',
    siteParamFacebook: 'todayshow',
    siteParamInstagram: 'todayshow',
    siteParamTwitter: 'today',
    siteParamYoutube: 'today',
    siteSite: '@TodayShow',
    siteUrl: 'http://www.today.com',
    twitterIntentVia: 'NBCNews',
  },
  msnbc: {
    iconUrl: 'msnbc',
    siteCreator: 'MSNBC',
    siteLogoUrl: 'https://sslnodeassets.nbcnews.com/cdnassets/projects/site-images/nbcnews-logo-white.png',
    siteName: 'MSNBC.com',
    siteParamFacebook: 'msnbc',
    siteParamInstagram: 'msnbc',
    siteParamTwitter: 'msnbc',
    siteParamYoutube: 'msnbc',
    siteSite: '@MSNBC',
    siteUrl: 'http://www.msnbc.com',
    twitterIntentVia: 'NBCNews',
  },
  noticias: {
    iconUrl: 'telemundo',
    siteCreator: 'TELEMUNDO',
    siteLogoUrl: 'https://sslnodeassets.nbcnews.com/cdnassets/projects/site-images/nbcnews-logo-white.png',
    siteName: 'TELEMUNDO.com',
    siteParamFacebook: 'noticiastelemundo',
    siteParamInstagram: 'NoticiasTelemundo',
    siteParamTwitter: 'TelemundoNews',
    siteParamYoutube: 'telemundo',
    siteSite: '@TELEMUNDO',
    siteUrl: 'http://www.telemundo.com',
    twitterIntentVia: 'TelemundoNews',
  },
};

const publicoHeadlineBrands = ['knowyourvalue', 'think', 'today'];

const isIn = (v, verticalList) => verticalList.indexOf(v) !== -1;

const isNotIn = (v, verticalList) => verticalList.indexOf(v) === -1;

const isMain = (v) => brands.indexOf(v) !== -1;

const isSub = (v) => newsVerticals.indexOf(v) !== -1;

const getDisplayNameForVertical = (vertical) => (verticalNameMap[vertical] || '');

const getSlugForVertical = (vertical) => (verticalSlugMap[vertical] || vertical);

const hasPublisherRestriction = (publisher, vertical) => {
  if (publisher && (
    // Only show MSNBC content on MSNBC
    (publisher !== 'msnbc' && vertical === 'msnbc')
    // Do not show MSNBC content on other domains
    || (publisher === 'msnbc' && vertical !== 'msnbc')
  )) {
    return true;
  }
  return false;
};

const isTelemundoVertical = (vertical) => telemundoVerticals.includes(vertical);


const getSiteConfigs = (vertical) => verticalSiteConfigs[vertical]
  || verticalSiteConfigs.news;

module.exports = {
  brands,
  getDisplayNameForVertical,
  getSiteConfigs,
  getSlugForVertical,
  hasPublisherRestriction,
  isIn,
  isMain,
  isNotIn,
  isSub,
  isTelemundoVertical,
  newsVerticals,
  publicoHeadlineBrands,
  telemundoVerticals,
  verticals,
  verticalNameMap,
  verticalSlugMap,
};
